export default __webpack_public_path__ + "static/media/kid-study.3102f4f5.jpg";